var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { App, NavController, NavParams, LoadingController } from 'ionic-angular';
/* Providers */
import { UserProvider } from '../../../providers/user';
import { AuthProvider } from '../../../providers/auth';
import { LogoutProvider } from '../../../providers/logout';
import { OnPremiseProvider } from '../../../providers/on-premise';
import { NavSidebarProvider } from '../../../providers/nav-sidebar';
export var AccountSettingsViews;
(function (AccountSettingsViews) {
    AccountSettingsViews["API_KEYS"] = "api-keys";
    AccountSettingsViews["API_ANALYTICS"] = "api-analytics";
    AccountSettingsViews["EXPORTS"] = "exports";
    AccountSettingsViews["ORGANIZATION"] = "organization";
    AccountSettingsViews["NOTIFICATION_PREFERENCES"] = "notification-preferences";
    AccountSettingsViews["CHANGE_PASSWORD"] = "change-password";
    AccountSettingsViews["SWITCH_ACCOUNT"] = "switch-account";
    AccountSettingsViews["ABOUT"] = "about";
})(AccountSettingsViews || (AccountSettingsViews = {}));
var SettingsSidebarComponent = /** @class */ (function () {
    function SettingsSidebarComponent(navCtrl, navParams, appCtrl, userProvider, loadingCtrl, logoutProvider, onPremiseProvider, authProvider, navSidebarProvider) {
        this.navCtrl = navCtrl;
        this.navParams = navParams;
        this.appCtrl = appCtrl;
        this.userProvider = userProvider;
        this.loadingCtrl = loadingCtrl;
        this.logoutProvider = logoutProvider;
        this.onPremiseProvider = onPremiseProvider;
        this.authProvider = authProvider;
        this.navSidebarProvider = navSidebarProvider;
        this.viewChangedEvent = new EventEmitter();
        this.views = AccountSettingsViews;
    }
    SettingsSidebarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.metadataSubscription = this.navSidebarProvider.currentMetadataSubscription.subscribe(function (metadata) {
            if (!metadata) {
                return;
            }
            _this.projectIdentifier = metadata.projectIdentifier;
            _this.datasetIdentifier = metadata.datasetIdentifier;
        });
    };
    SettingsSidebarComponent.prototype.ngOnDestroy = function () {
        this.metadataSubscription.unsubscribe();
    };
    // can be moved to app component in future if we have logout function at multiple locations
    /**
     * Logout user from the application
     */
    SettingsSidebarComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.logoutProvider.logout()];
                    case 1:
                        _a.sent();
                        this.appCtrl.getActiveNavs()[0].setRoot('LoginPage');
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SettingsSidebarComponent.prototype.onViewChanged = function (newView) {
        this.currentView = newView;
        this.viewChangedEvent.emit(newView);
    };
    SettingsSidebarComponent.prototype.canUseAPIAnalytics = function () {
        return this.userProvider.canManageDatasets() && this.userProvider.hasInferenceAPICapability();
    };
    SettingsSidebarComponent.prototype.createUpgradeLink = function () {
        var user = this.userProvider.getUserInformation();
        // this prevents user from being undefined and breaking the page if there's a delay in fetching the user in ngOnInit.
        if (user.name) {
            var nameSplit = user.name.split(' ');
            // This assumes that the user has only a first and last name; this might be difficult for non-Western names or those with double names
            var firstName = nameSplit.shift();
            var lastName = nameSplit.join(' ');
            var email = user.email.replace(/\+/g, '%2B');
            return "https://info.neurala.com/upgrade?firstname=" + firstName + "&lastname=" + lastName + "&email=" + email;
        }
    };
    SettingsSidebarComponent.prototype.createKBLink = function () {
        return "http://support.neurala.com/home/";
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], SettingsSidebarComponent.prototype, "currentView", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], SettingsSidebarComponent.prototype, "viewChangedEvent", void 0);
    SettingsSidebarComponent = __decorate([
        Component({
            selector: 'settings-sidebar',
            templateUrl: 'settings-sidebar.html'
        }),
        __param(0, ViewChild('myNav')),
        __metadata("design:paramtypes", [NavController,
            NavParams,
            App,
            UserProvider,
            LoadingController,
            LogoutProvider,
            OnPremiseProvider,
            AuthProvider,
            NavSidebarProvider])
    ], SettingsSidebarComponent);
    return SettingsSidebarComponent;
}());
export { SettingsSidebarComponent };
//# sourceMappingURL=settings-sidebar.js.map


// WEBPACK FOOTER //
// ./src/components/core/settings-sidebar/settings-sidebar.ts.pre-build-optimizer.js